<template>
  <v-card
    class="rounded-lg"
  >
    <slot name="header" />
    <apexchart
      type="radialBar"
      :height="height"
      :width="width"
      :options="chartOptions"
      :series="limitedSeries"
    />
    <slot name="footer" />
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'RadialBarChart',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    series: {
      type: Array,
      required: true
    },
    colors: {
      type: Array,
      default: () => ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0']
    },
    height: {
      type: Number,
      default: 350
    },
    width: {
      type: Number,
      default: undefined
    },
    plotOptions: {
      type: Object,
      default: () => ({})
    },
    animations: {
      type: Object,
      default: () => ({})
    },
    labels: {
      type: Array,
      default: () => []
    },
    tooltip: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    limitedSeries() {
      return this.series.map((s) => Math.min(s, 100))
    },
    chartOptions() {
      return {
        colors: this.colors,
        chart: {
          type: 'radialBar',
          height: this.height,
          animations: this.animations
        },
        plotOptions: this.plotOptions,
        labels: this.labels,
        tooltip: this.tooltip,
        states: {
          active: {
            filter: {
              type: 'none'
            }
          }
        }
      }
    }
  }
}
</script>
